import React, { useRef, memo } from 'react';
import { motion, useInView } from 'framer-motion';
import { SearchIcon, BrainCircuitIcon, HeartPulseIcon } from 'lucide-react';
const steps = [{
  number: 1,
  icon: SearchIcon,
  title: 'Identify',
  description: 'Look up your specific aches, pains, or symptoms in the A-Z directory.'
}, {
  number: 2,
  icon: BrainCircuitIcon,
  title: 'Decode',
  description: 'Read the specific emotional conflict and ask the "Core Questions" to trigger a memory of the trauma.'
}, {
  number: 3,
  icon: HeartPulseIcon,
  title: 'Release',
  description: 'Use the targeted Release Scripts to tell your brain the "danger" is over and start the biological repair.'
}];
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy-light py-20 px-6 md:px-12" data-id="element-68">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto space-y-12" data-id="element-69">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center" data-id="element-70">
          How It Works
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-71">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="relative bg-dark-navy p-8 rounded-lg space-y-4 border border-teal-accent/20 cyan-glow" data-id="element-72">
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-teal-accent rounded-full flex items-center justify-center font-bold text-dark-navy text-xl shadow-[0_0_15px_rgba(0,243,255,0.5)]" data-id="element-73">
                {step.number}
              </div>
              <div className="w-16 h-16 bg-teal-accent/10 rounded-lg flex items-center justify-center mx-auto" data-id="element-74">
                <step.icon className="w-8 h-8 text-teal-accent" data-id="element-75" />
              </div>
              <h3 className="text-2xl font-bold text-white text-center" data-id="element-76">
                {step.title}
              </h3>
              <p className="text-stone-400 leading-relaxed text-center" data-id="element-77">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}